module.exports = __webpack_public_path__ + "static/media/Matt Wildman.ba93db99.jpg";